import { ref, computed } from 'vue'
import type { Schemas } from '#shopware'
import { useCheckout as swUseCheckout, useShopwareContext } from '@shopware/composables'

export function useCheckout() {
    const {
        paymentMethods: swPaymentMethods,
        getPaymentMethods: swGetPaymentMethods,
        ...coreUseCheckout
    } = swUseCheckout()
    const { apiClient } = useShopwareContext()

    const orderPaymentMethods = ref<Schemas['PaymentMethod'][] | null>(null)

    const paymentMethods = computed(() => orderPaymentMethods.value ?? swPaymentMethods.value)

    async function getPaymentMethods(orderId?: string) {
        if (orderId) {
            const response = await apiClient.invoke(
                'readPaymentMethod post /payment-method',
                { body: { onlyAvailable: true, orderId } as Schemas['Criteria'] & { onlyAvailable?: boolean } }
            )
            orderPaymentMethods.value = response.data.elements ?? []
            return paymentMethods
        }

        orderPaymentMethods.value = null
        return swGetPaymentMethods()
    }

    return {
        ...coreUseCheckout,
        paymentMethods,
        getPaymentMethods,
    }
}
